<template>
  <Public bg="tw-bg-light-gray" header="custom-header" headerText="เลือกวิธีการชำระเงิน"
          headerSubText="ให้เราเป็นส่วนหนึ่งของคุณง่ายๆ เพียง 4 ขั้นตอน">

    <div class="tw-container tw-mx-auto tw-mt-8 tw-mb-16 tw-max-w-2xl tw-p-4">

      <div class="tw-prose tw-max-w-none tw-text-left tw-pb-10">
        <div class="md:tw-flex tw-items-start tw-py-2 md:tw-space-x-4 tw-space-y-4 md:tw-space-y-0">

          <div class="tw-p-4 tw-w-full md:tw-w-1/2 tw-bg-white tw-rounded-lg tw-shadow">
            <form :action="cloudFunctionUrl+'paymentGatewayCreditCardCheckout?companyID='+companyID" id="2c2p-payment-form"
                  method="post">
              <input type="text" data-encrypt="cardnumber" maxlength="16" placeholder="Credit Card Number"><br/>
              <input type="text" data-encrypt="month" maxlength="2" placeholder="MM"><br/>
              <input type="text" data-encrypt="year" maxlength="4" placeholder="YYYY" autocomplete="new-password"><br/>
              <input type="password" data-encrypt="cvv" maxlength="4" autocomplete="new-password"
                     placeholder="CVV2/CVC2"><br/>
              <!--              <v-radio-->
              <!--                label="ชำระเงินผ่านบัตรเครดิต / บัตรเดบิต"-->
              <!--                value="credit-card"-->
              <!--              ></v-radio>-->
              <hr class="tw-my-4">
              <button type="submit" :disabled="!companyCerRequest || !companyCerRequest['price']"
                      class="tw-float-right tw-bg-light-green tw-text-white tw-py-2 tw-px-6 tw-rounded-md disabled:opacity-50">ชำระเงิน
              </button>
            </form>

          </div>

          <div class="tw-p-4 tw-w-full md:tw-w-1/2 tw-bg-white tw-rounded-lg tw-shadow">
            <div>ยอดรวมค่าใช้จ่าย</div>
            <div class="tw-text-light-green tw-text-3xl tw-font-bold">{{getPrice()}}</div>
            <hr class="tw-my-4">
            <div class="tw-mb-2"><strong>รายละเอียด</strong></div>

            <div class="tw-flex tw-justify-between" v-if="companyCerRequest && companyCerRequest['requestCertificate']">
              <span>ใบรับรองอิเล็กทรอนิกส์</span>
              <span>3,000 บาท</span>
            </div>
            <div class="tw-flex tw-justify-between" v-if="companyCerRequest && companyCerRequest['requestDigitalSignature']">
              <span>การลงลายมือชื่อดิจิทัล</span>
              <span>2,000 บาท</span>
            </div>
            <div class="tw-flex tw-justify-between">
              <span>บริการ e-Tax Setup</span>
              <span>4,900 บาท</span>
            </div>
            <div class="tw-flex tw-justify-between" v-if="companyCerRequest && companyCerRequest['requestERPConnect']">
              <span>บริการเชื่อมต่อ ERP</span>
              <span>15,000 บาท</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-web></footer-web>
  </Public>
</template>

<script>
import {mapState} from 'vuex'
import FooterWeb from '@/components/public/footer'
import Public from '@/components/public/public-main-template'
import fc from '@/firebaseConfig'


// const _ = require('lodash');

export default {
  name: 'Payment',
  components: {
    FooterWeb,
    Public
  },
  data: function () {
    return {
      errorMessage: "",
      cloudFunctionUrl: fc.cloudFunctionUrl,
      companyID: this.$route.params.companyId
    }
  },
  computed: mapState({
    companyCerRequest: state => state.companies.companyCerRequest
  }),
  mounted() {
    this.$store.dispatch('companies/getList');
    this.getCerRequest();
    let _this = this;
    window.My2c2p.onSubmitForm("2c2p-payment-form", function (errCode, errDesc) {
      if (errCode != 0) {
        alert(errDesc + " (" + errCode + ")");
        _this.errorMessages = errDesc;
      }
    });
  },
  methods: {
    getCerRequest: function () {
      let companyID = this.$route.params.companyId
      if (companyID) {
        this.$store.dispatch('companies/getCerRequest', {companyID})
      }
    },
    getPrice: function () {
      return this.companyCerRequest && this.companyCerRequest['price'] ?  `${this.companyCerRequest['price'].toLocaleString()} บาท` : "4,900 บาท"
    }
  }
}
</script>
